export default {
      id: "apple-usage",
      viewBox: "0 0 23.456 27.788",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#apple",
      toString: function () {
        return this.url;
      }
    }